import { atom } from 'jotai';
import { $ABTest } from '@lemon8/web-app-shared/atom';
import _get from 'lodash/get';

export const $VideoFullExpand = atom<boolean>((get) => {
  const { parameters } = get($ABTest);

  if (__BUILD_TYPE__ === 'local_dev') {
    return true;
  }

  return Boolean(_get(parameters, ['seo_web', 'lemon8.video_full_expand'], false));
});
